// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"142":"analytics","314":"setting","535":"login","830":"signup","845":"profile","966":"dashboard"}[chunkId] || chunkId) + "." + {"142":"981be7e7","314":"35f7b004","535":"ddc788cb","684":"00f35ab2","830":"65790a80","845":"b82e1215","966":"983fb3a5","978":"c2b4f4fc"}[chunkId] + ".js";
};